<template>
    <div class="container">
        <ActionBar
            @openParentClaim="openParentClaim"
            @inviteUser="inviteUser"
            :isChildView="isChildView"
        ></ActionBar>

        <div class="main-claim">
            <MainClaim v-if="mainClaim" 
                @newSupportingReply="newReply('supporting')"
                @newOpposingReply="newReply('opposing')"
                :claim="mainClaim">
            </MainClaim>
        </div>

        <ClaimTree 
            v-if="claims.length"
            @claimUpdated="claimUpdated"
            @openClaim="openChildClaim"
            @percentEdited="percentEdited"
            :mainClaim="mainClaim"
            :claims="claims"
            :percentTotals="percentTotals"
            :percents="percents"
            :supporting="supporting"
            :opposing="opposing"
        ></ClaimTree>
        <!-- <Tray>
            <NewClaimForm class="new-claim-form"></NewClaimForm>
        </Tray> -->
    </div>
</template>

<script>
    import MainClaim from '../components/MainClaim.vue';
    import ClaimTree from '../components/ClaimTree.vue';
    // import Tray from '../components/Tray.vue';
    import ActionBar from '../components/ActionBar.vue';
    import NewClaimForm from '../components/NewClaimForm.vue';
    import { DEFAULT } from '../utility/Status';

    export default {
        created() {
            this.$store.dispatch('claims/loadClaim', this.$route.params.id);
            this.$store.dispatch('claims/loadClaims');
        },
        methods: {
            newReply(type) {
                const tempClaim = {
                    id: this.$id(),
                    parentId: this.mainClaim.id,
                    status: DEFAULT,
                    new: true,
                    type
                };

                if (type === 'supporting') {
                    this.temporarySupportingClaim = tempClaim;
                } else {
                    this.temporaryOpposingClaim = tempClaim;
                }
            },
            claimUpdated(e) {
                if (e.new && e.title) {
                    this.$store.dispatch('claims/createChildClaim', e);
                } else if (e.title) {
                    this.$store.dispatch('claims/updateClaim', e);
                }
            },
            openParentClaim() {
                const lastSlashIndex = this.$route.path.lastIndexOf('/');
                const parentPath = this.$route.path.slice(0, lastSlashIndex);
                this.$router.push({path: parentPath });
            },
            openChildClaim(id) {
                this.$router.push({path: `${this.$route.path}/${id}` });
            },
            inviteUser(e) {
                this.$store.dispatch('claims/invite', {
                    id: this.mainClaim.id,
                    email: e
                });
            },
            percentEdited(e) {
                this.$store.dispatch('claims/updateClaimPercents', {
                    id: this.mainClaim.id,
                    percents: {
                        [e.id]: e.percent
                    }
                });
            }
        },
        data() {
            return {
                temporarySupportingClaim: undefined,
                temporaryOpposingClaim: undefined
            };
        },
        computed: {
            isChildView() {
                return this.$route.name === 'ChildClaim';
            },
            mainClaim() {
                const c = this.$store.getters['claims/getClaim'];
                return c(this.$route.params.id);
            },
            claims() {
                return this.$store.getters['claims/getClaims']
                    .concat(this.temporarySupportingClaim || [])
                    .concat(this.temporaryOpposingClaim || []);
            },
            percentTotals() {
                return {
                    supporting: this.mainClaim.supportingPercentTotal,
                    opposing: this.mainClaim.opposingPercentTotal
                };
            },
            percents() {
                const percents = {
                    ...this.mainClaim.percents
                };
                if (this.temporarySupportingClaim) {
                    percents.displaySupporting[this.temporarySupportingClaim.id] = 0;
                    percents.actualSupporting[this.temporarySupportingClaim.id] = 0;
                }
                if (this.temporaryOpposingClaim) {
                    percents.displayOpposing[this.temporaryOpposingClaim.id] = 0;
                    percents.actualOpposing[this.temporaryOpposingClaim.id] = 0;
                }
                return percents;
            },
            supporting() {
                return this.temporarySupportingClaim ?
                    [this.temporarySupportingClaim.id].concat(this.mainClaim.supporting)
                    :
                    this.mainClaim.supporting;
            },
            opposing() {
                return this.temporaryOpposingClaim ?
                    [this.temporaryOpposingClaim.id].concat(this.mainClaim.opposing)
                    :
                    this.mainClaim.opposing;
            }
        },
        watch: {
            claims(newValue, oldValue) {
                if (this.temporarySupportingClaim) {
                    const createdSupporting = newValue.find(c => {
                        return this.temporarySupportingClaim.id === c.id && !c.new;
                    });
                    if (createdSupporting) {
                        this.temporarySupportingClaim = undefined;
                    }
                }

                if (this.temporaryOpposingClaim) {
                    const createdOpposing = newValue.find(c => {
                        return this.temporaryOpposingClaim.id === c.id && !c.new;
                    });
                    if (createdOpposing) {
                        this.temporaryOpposingClaim = undefined;
                    }
                }
            }
        },
        components: {
            ActionBar,
            MainClaim,
            ClaimTree,
            NewClaimForm,
            // Tray
        }
    }
</script>

<style scoped lang="scss">
    .container {
        width: 1200px;
        margin: 0 auto;
    }
    .new-claim-form {
        background-color: white;
        width: 100%;
        height: 100%;
        padding: $space-32;
        box-sizing: border-box;
        border-radius: $space-4;
    }
</style>